const _ = require('lodash');
const { colors } = require('./../tailwind');
const shadows = require('./shadow-styles.js');
const fontSizeStyles = require('./styleDefs/fontSizeStyles');

function mapToStyles(dictionary, cssProp, prefix = '', extraProps) {
  const newStyles = {};
  _.forEach(dictionary, (v, k) => {
    let newProp = {
      [cssProp]: v,
    };
    if (extraProps) {
      newProp = Object.assign({}, newProp, extraProps);
    }
    newStyles[prefix + k] = newProp;
  });
  return newStyles;
}

const colorsMap = colors;

const colorStyles = mapToStyles(colorsMap, 'color');

const bgColorStyles = mapToStyles(colorsMap, 'backgroundColor', 'bg-');
const hoverColorStyles = mapToStyles(colorsMap, 'backgroundColor', 'hover-');

const fonts = {
  'Metropolis': 'Metropolis',
  pn: 'Metropolis',
  helvetica: 'Helvetica',
  hel: 'Helvetica',
};

const fontStyles = mapToStyles(fonts, 'fontFamily');

const fontWeightStyles = {
  thin: { fontWeight: 'thin' },
  light: { fontWeight: 'light' },
  normal: { fontWeight: 'normal' },
  medium: { fontWeight: 'medium' },
  semibold: { fontWeight: 'semibold' },
  bold: {
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
  },
};

const borderWidths = {
  0: 0,
  1: 1,
  2: 2,
  4: 4,
  8: 8,
};

const borderStyles = mapToStyles(borderWidths, 'borderWidth', 'b-', {
  borderStyle: 'solid',
});
const borderColorStyles = mapToStyles(colorsMap, 'borderColor', 'b-');
const borderTopStyles = mapToStyles(borderWidths, 'borderTop', 'bt-', {
  borderStyle: 'solid',
});
const borderLeftStyles = mapToStyles(borderWidths, 'borderLeft', 'bl-', {
  borderStyle: 'solid',
});
const borderRightStyles = mapToStyles(borderWidths, 'borderRight', 'br-', {
  borderStyle: 'solid',
});
const borderBottomStyles = mapToStyles(borderWidths, 'borderBottom', 'bb-', {
  borderStyle: 'solid',
});

const borderRadius = {
  none: 0,
  sm: 2,
  md: 4,
  m: 4,
  mx: 10,
  mxx: 20,
  mxxx: 40,
  full: 9999,
};

const borderRadiusStyles = mapToStyles(borderRadius, 'borderRadius', 'brad-');
const borderTopLeftRadiusStyles = mapToStyles(borderRadius, 'borderTopLeftRadius', 'brad-tl-');
const borderTopRightRadiusStyles = mapToStyles(borderRadius, 'borderTopRightRadius', 'brad-tr-');
const borderBottomLeftRadiusStyles = mapToStyles(borderRadius, 'borderBottomLeftRadius', 'brad-bl-');
const borderBottomRightRadiusStyles = mapToStyles(borderRadius, 'borderBottomRightRadius', 'brad-br-');

const display = {
  block: 'block',
  inline: 'inline',
  'inline-block': 'inline-block',
  none: 'none',
};

const displayStyles = mapToStyles(display, 'display');

const cursor = {
  pointer: 'pointer',
};

const cursorStyles = mapToStyles(cursor, 'cursor');

const position = {
  relative: 'relative',
  absolute: 'absolute',
  fixed: 'fixed',
};

const positionStyles = mapToStyles(position, 'position');

const positionSpacingStyles = {};

_.times(250, n => (positionSpacingStyles[`bottom-${n}`] = { bottom: n }));
_.times(250, n => (positionSpacingStyles[`bottom--${n}`] = { bottom: -n }));
_.times(250, n => (positionSpacingStyles[`top-${n}`] = { top: n }));
_.times(250, n => (positionSpacingStyles[`top--${n}`] = { top: -n }));
_.times(250, n => (positionSpacingStyles[`left-${n}`] = { left: n }));
_.times(250, n => (positionSpacingStyles[`right-${n}`] = { right: n }));
_.times(250, n => (positionSpacingStyles[`left--${n}`] = { left: -n }));
_.times(250, n => (positionSpacingStyles[`right--${n}`] = { right: -n }));
_.times(
  250,
  n =>
    (positionSpacingStyles[`absolute-${n}`] = {
      position: 'absolute',
      right: n,
      left: n,
      top: n,
      bottom: n,
    }),
);

const heightStyles = { 'h-null': { height: null } };

_.times(512, n => (heightStyles[`h-${n}`] = { height: n }));
_.times(101, n => (heightStyles[`h-${n}p`] = { height: `${n}%` }));
_.times(101, n => (heightStyles[`vh-${n}`] = { height: `${n}vh` }));
_.times(512, n => (heightStyles[`h-min-${n}`] = { minHeight: n }));

const widthStyles = { 'w-null': { width: null } };

_.times(4096, n => (widthStyles[`w-${n}`] = { width: n }));
_.times(512, n => (widthStyles[`w-min-${n}`] = { minWidth: n }));
_.times(1400, n => (widthStyles[`w-max-${n}`] = { maxWidth: n }));
_.times(101, n => (widthStyles[`w-${n}p`] = { width: `${n}%` }));

widthStyles['w-max-content'] = { maxWidth: 1080 };
widthStyles['w-max-container'] = { maxWidth: '100%' };

_.times(101, n => (widthStyles[`o-${n}`] = { opacity: n / 100 + '' }));

const zIndexStyles = {};

_.times(100, n => (zIndexStyles[`z-${n}`] = { zIndex: n.toString() }));

const padding = {
  px: 1,
  none: 0,
  sxxx: 2,
  sxx: 4,
  sx: 6,
  s: 8,
  m: 12,
  mx: 14,
  mxx: 16,
  mxxx: 18,
  l: 24,
  lx: 28,
  lxx: 36,
  lxxx: 48,
  xl: 64,
  xlx: 96,
  xlxx: 128,
  xlxxx: 164,
};

const paddingStyles = mapToStyles(padding, 'padding', 'p-');
const paddingTopStyles = mapToStyles(padding, 'paddingTop', 'pt-');
const paddingBottomStyles = mapToStyles(padding, 'paddingBottom', 'pb-');
const paddingLeftStyles = mapToStyles(padding, 'paddingLeft', 'pl-');
const paddingRightStyles = mapToStyles(padding, 'paddingRight', 'pr-');
const paddingHorizontalStyles = {};
_.forEach(
  padding,
  (psize, k) =>
    (paddingHorizontalStyles[`px-${k}`] = {
      paddingLeft: psize,
      paddingRight: psize,
    }),
);
const paddingVerticalStyles = {};
_.forEach(
  padding,
  (psize, k) =>
    (paddingVerticalStyles[`py-${k}`] = {
      paddingTop: psize,
      paddingBottom: psize,
    }),
);

const margin = {
  px: 1,
  none: 0,
  sxxx: 2,
  sxx: 4,
  sx: 6,
  s: 8,
  m: 12,
  mx: 14,
  mxx: 16,
  mxxx: 18,
  l: 24,
  lx: 28,
  lxx: 36,
  lxxx: 48,
  xl: 64,
  xlx: 96,
  xlxx: 128,
  xlxxx: 164,
};

const marginStyles = mapToStyles(margin, 'margin', 'm-');
const marginTopStyles = mapToStyles(margin, 'marginTop', 'mt-');
const marginBottomStyles = mapToStyles(margin, 'marginBottom', 'mb-');
const marginLeftStyles = mapToStyles(margin, 'marginLeft', 'ml-');
const marginRightStyles = mapToStyles(margin, 'marginRight', 'mr-');

const marginHorizontalStyles = {};
_.forEach(
  margin,
  (psize, k) =>
    (marginHorizontalStyles[`mx-${k}`] = {
      marginLeft: psize,
      marginRight: psize,
    }),
);
const marginVerticalStyles = {};
_.forEach(
  margin,
  (psize, k) =>
    (marginVerticalStyles[`my-${k}`] = {
      marginTop: psize,
      marginBottom: psize,
    }),
);

const shadowStyles = mapToStyles(shadows, 'box-shadow', 'sh-');

const directionStyles = {
  'f-rows': { flexDirection: 'column', display: 'flex' },
  'f-rows-reverse': { flexDirection: 'column-reverse', display: 'flex' },
  'f-columns': { flexDirection: 'row', display: 'flex' },
  'f-columns-reverse': { flexDirection: 'row-reverse', display: 'flex' },
};

const wrap = {
  nowrap: 'nowrap',
  wrap: 'wrap',
  'wrap-reverse': 'wrap-reverse',
};
const wrapStyles = mapToStyles(wrap, 'flexWrap', 'f-');

const justify = {
  start: 'flex-start',
  'flex-start': 'flex-start',
  end: 'flex-end',
  'flex-end': 'flex-end',
  center: 'center',
  'space-around': 'space-around',
  'space-between': 'space-between',
};

const justifyStyles = mapToStyles(justify, 'justifyContent', 'f-');
const justifyItemsStyles = mapToStyles(justify, 'justifyItems', 'f-ji-');

const align = {
  'align-stretch': 'stretch',
  'align-baseline': 'baseline',
  'align-center': 'center',
  'align-start': 'flex-start',
  'align-end': 'flex-end',
};

const alignItemsStyles = mapToStyles(align, 'alignItems', 'f-');

const comboAlignmentStyles = {
  'f-center-center': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  'f-center-start': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  'f-center-end': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  'f-center-baseline': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
  },
  'f-center-stretch': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  'f-start-center': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  'f-start-start': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  'f-start-end': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  'f-start-baseline': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'baseline',
  },
  'f-start-stretch': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  'f-end-center': {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  'f-end-start': {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  'f-end-end': {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  'f-end-baseline': {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'baseline',
  },
  'f-end-stretch': {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'stretch',
  },
  'f-around-center': {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  'f-around-start': {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
  },
  'f-around-end': {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'flex-end',
  },
  'f-around-baseline': {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'baseline',
  },
  'f-around-stretch': {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'stretch',
  },
  'f-between-center': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  'f-between-start': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  'f-between-end': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  'f-between-baseline': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  'f-between-stretch': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  'f-cc': { display: 'flex', justifyContent: 'center', alignItems: 'center' },
  'f-sc': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  'f-ec': {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  'f-bc': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};

const alignContent = {
  'content-stretch': 'stretch',
  'content-center': 'center',
  'content-flex-start': 'flex-start',
  'content-flex-end': 'flex-end',
  'content-space-around': 'space-around',
  'content-space-between': 'space-between',
};

const alignContentStyles = mapToStyles(alignContent, 'alignContent', 'f-');

const alignSelf = {
  'self-auto': 'auto',
  'self-flex-start': 'flex-start',
  'self-flex-end': 'flex-end',
  'self-center': 'center',
  'self-stretch': 'stretch',
  'self-baseline': 'baseline',
};

const alignSelfStyles = mapToStyles(alignSelf, 'alignSelf', 'f-');

const flexStyles = { f: { display: 'flex' } };
_.times(100, n => (flexStyles[`f-${n}`] = { flex: n.toString() }));
_.times(100, n => (flexStyles[`f-s-${n}`] = { flexShrink: n.toString() }));

const gridAutoFlow = {
  column: 'column',
  row: 'row',
  'row-dense': 'row dense',
  'column-dense': 'column dense',
  dense: 'dense',
};
const gridAutoFlowStyles = mapToStyles(gridAutoFlow, 'grid-auto-flow', 'g-af');
const gridGapStyles = mapToStyles(margin, 'grid-gap', 'g-g-');

const gridTemplateColumnStyles = {
  /*custom templates go here*/
  g: { display: 'grid' },
  'g-tc-7-grow-4': {
    gridTemplateColumns: 'auto auto auto 1fr auto auto auto',
  },
  'g-tc-1a1': {
    gridTemplateColumns: '1fr auto 1fr',
  },
  'g-tc-a1a': {
    gridTemplateColumns: 'auto 1fr auto',
  },
  'g-tc-1a': {
    gridTemplateColumns: '1fr auto',
  },
  'g-tc-a1': {
    gridTemplateColumns: 'auto 1fr ',
  },
  'g-cs-1-2': {
    'grid-column': '1 / span 2',
  },
};
_.times(
  20,
  n =>
    (gridTemplateColumnStyles[`g-tc-${n * 25}`] = {
      'grid-template-columns': 'repeat(auto-fit, minmax(' + (n * 25).toString() + 'px, 1fr))',
    }),
);
_.times(
  20,
  n =>
    (gridTemplateColumnStyles[`g-tc-fr-${n}`] = {
      'grid-template-columns': `repeat(${n}, 1fr)`,
    }),
);

_.times(
  20,
  n =>
    (gridTemplateColumnStyles[`g-tc-a-${n}`] = {
      'grid-template-columns': `repeat(${n}, auto)`,
    }),
);

const buttonStyles = {
  btn: {
    borderRadius: borderRadius.full,
    padding: padding.m,
  },
  'btn-text': {
    color: colorsMap.white,
  },
  'btn-primary': {
    backgroundColor: colorsMap.primary,
  },
  'btn-secondary': {
    backgroundColor: colorsMap.secondary,
  },
  'btn-search-icon': {
    borderTopRightRadius: 50,
    borderTopLeftRadius: 0,
    borderBottomRightRadius: 50,
    borderBottomLeftRadius: 0,
  },
  'bg-pattern': {
    backgroundImage: `repeating-linear-gradient(45deg, #159CE933, #159CE933 15px, #00ADEE66 15px, #00ADEE66 30px)`,
  },
  'bg-pattern-2': {
    backgroundImage: `repeating-linear-gradient(45deg, #ebebeb, #ebebeb 15px, #fff 15px, #fff 30px)`,
  },
};

const styleStrings = {
  modal: {
    outer: 'fixed top-0 bottom-0 left-0 right-0 f-cc z-50',
    shadow: 'fixed top-0 bottom-0 left-0 right-0 px-l bg-grayDark o-40',
    inner: 'relative bg-white p-l m-lxx brad-md',
  },
  hr: 'b-0 bb-1 b-cool-gray-lightest',
};

const overFlowStyles = {
  'o-hidden': { overflow: 'hidden' },
  'o-visible': { overflow: 'visible' },
  'o-scroll': { overflow: 'scroll' },
  'o-auto': { overflow: 'scroll' },
  'o-x-auto': { overflowX: 'auto' },
  'o-x-hidden': { overflowX: 'hidden' },
  'o-y-auto': { overflowY: 'auto' },
};

const imageStyles = {
  cover: { objectFit: 'cover' },
  contain: { objectFit: 'contain' },
};

const styleMap = Object.assign(
  {},

  borderStyles,
  borderBottomStyles,
  borderTopStyles,
  borderLeftStyles,
  borderRadiusStyles,
  borderRightStyles,
  borderColorStyles,
  imageStyles,
  shadowStyles,
  fontStyles,
  fontWeightStyles,
  fontSizeStyles,
  paddingTopStyles,
  paddingLeftStyles,
  paddingRightStyles,
  paddingBottomStyles,
  paddingStyles,
  paddingHorizontalStyles,
  paddingVerticalStyles,
  marginStyles,
  marginLeftStyles,
  marginRightStyles,
  marginTopStyles,
  marginBottomStyles,
  marginHorizontalStyles,
  marginVerticalStyles,
  displayStyles,
  cursorStyles,
  overFlowStyles,
  positionStyles,
  wrapStyles,
  justifyStyles,
  justifyItemsStyles,
  directionStyles,
  alignSelfStyles,
  alignItemsStyles,
  alignContentStyles,
  comboAlignmentStyles,
  flexStyles,
  buttonStyles,
  widthStyles,
  heightStyles,
  positionSpacingStyles,
  gridAutoFlowStyles,
  gridTemplateColumnStyles,
  gridGapStyles,
  zIndexStyles,
  borderTopLeftRadiusStyles,
  borderTopRightRadiusStyles,
  borderBottomLeftRadiusStyles,
  borderBottomRightRadiusStyles,
  colorStyles,
  bgColorStyles,
  hoverColorStyles,
);

function buildStyles(namesStr, styleMap) {
  if (!namesStr || !styleMap) {
    return [];
  }

  const namesArr = namesStr.trim().split(' ');
  const styles = namesArr.map(name => (name && styleMap[name]) || {});
  return styles;
}

styleMap.buildStyles = buildStyles;
styleMap.bs = buildStyles;
styleMap.mapToStyles = mapToStyles;
styleMap.styleStrings = styleStrings;

module.exports = styleMap;



// WEBPACK FOOTER //
// ./src/helpers/styles-core.js